var map = {
	"./8an-bull.jpg": "ce61",
	"./8an-bull.mp3": "1ead",
	"./8an-cat.jpg": "60bf",
	"./8an-cat.mp3": "9e0f",
	"./8an-dog.jpg": "75ea",
	"./8an-dog.mp3": "4152",
	"./8an-fox.jpg": "3804",
	"./8an-fox.mp3": "e390",
	"./8an-puma.jpg": "525d",
	"./8an-puma.mp3": "e3ef",
	"./8an-rooster.jpg": "c851",
	"./8an-rooster.mp3": "6f45",
	"./8an-sheep.jpg": "ce01",
	"./8an-sheep.mp3": "63d5",
	"./8an-turkey.jpg": "5de0",
	"./8an-turkey.mp3": "9939"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";